// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { Token } from '@lumino/coreutils';
// documented upstream constants
export const MERMAID_MIME_TYPE = 'text/vnd.mermaid';
export const MERMAID_FILE_EXTENSIONS = ['.mmd', '.mermaid'];
// layout sniffing
export const RE_DEFAULT_RENDERER = /\bdefaultRenderer["']?\s*:\s*(["']?)(\b[^"'\s]+\b)(\1)/gm;
// mermaid themes
export const MERMAID_DEFAULT_THEME = 'default';
export const MERMAID_DARK_THEME = 'dark';
// DOM
export const MERMAID_CLASS = 'jp-RenderedMermaid';
export const MERMAID_CODE_CLASS = 'mermaid';
export const WARNING_CLASS = 'jp-mod-warning';
export const DETAILS_CLASS = 'jp-RenderedMermaid-Details';
export const SUMMARY_CLASS = 'jp-RenderedMermaid-Summary';
/**
 * The exported token for a mermaid manager
 */
export const IMermaidManager = new Token('@jupyterlab/mermaid:IMermaidManager', `a manager for rendering mermaid text-based diagrams`);
/**
 * The exported token for a mermaid manager
 */
export const IMermaidMarkdown = new Token('@jupyterlab/mermaid:IMermaidMarkdown', `a manager for rendering mermaid text-based diagrams in markdown fenced code blocks`);
//# sourceMappingURL=tokens.js.map